"use client";

import { useTranslations } from "next-intl";

export const CandidatesEmptyState: React.FC = () => {
  const t = useTranslations("dao");
  return (
    <div className="flex flex-col items-center gap-4 py-8 text-center">
      <p className="text-sm text-text-secondary">
        {t("election.candidates.empty")}
      </p>
    </div>
  );
};
